import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ResetItem = Loadable(
  lazy(() => import("features/resetItem/components/ResetItem"))
);

const routes = {
  path: "resetItem",
  children: [{ path: "", element: <ResetItem /> }],
};

export default routes;
